module.exports = __webpack_public_path__ + "img/ukasko-bonus.c4128969.svg";